/**
 * 虚拟键盘 key map
 * 移动设备上模拟输入键,现有 4 行
 */
export const LetterKeyMap = [
    // 1-------------------------------------------------------------------------
    [   
        {
            key: 'KeyQ',
            title: 'q',
        },
        {
            key: 'KeyW',
            title: 'w',
        },
        {
            key: 'KeyE',
            title: 'e',
        },
        {
            key: 'KeyR',
            title: 'r',
        },
        {
            key: 'KeyT',
            title: 't',
        },
        {
            key: 'KeyY',
            title: 'y',
        },
        {
            key: 'KeyU',
            title: 'u',
        },
        {
            key: 'KeyI',
            title: 'i',
        },
        {
            key: 'KeyO',
            title: 'o',
        },
        {
            key: 'KeyP',
            title: 'p',
        },
    ],
    // 2-------------------------------------------------------------------------
    [{
            key: 'KeyA',
            title: 'a',
        },
        {
            key: 'KeyS',
            title: 's',
        },
        {
            key: 'KeyD',
            title: 'd',
        },
        {
            key: 'KeyF',
            title: 'f',
        },
        {
            key: 'KeyG',
            title: 'g',
        },
        {
            key: 'KeyH',
            title: 'h',
        },
        {
            key: 'KeyJ',
            title: 'j',
        },
        {
            key: 'KeyK',
            title: 'k',
        },
        {
            key: 'KeyL',
            title: 'l',
        },
    ],
    // 3-------------------------------------------------------------------------
    [
        {
            key: 'KeyZ',
            title: 'z',
        },
        {
            key: 'KeyX',
            title: 'x',
        },
        {
            key: 'KeyC',
            title: 'c',
        },
        {
            key: 'KeyV',
            title: 'v',
        },
        {
            key: 'KeyB',
            title: 'b',
        },
        {
            key: 'KeyN',
            title: 'n',
        },
        {
            key: 'KeyM',
            title: 'm',
        },
    ],
    // 4-------------------------------------------------------------------------
    [
        {
            key: 'Slash',
            title: '/',
        },
        {
            key: 'Period',
            title: '.',
        },
        {
            key: 'Enter',
            title: 'enter',
        },
    ],
];